module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAJFBMVEUAAAAatl3kPEwbuV7oPEoatl7lPkwbt13kPk3///8btl3kPUy70kFGAAAACXRSTlMA8PAmJq6ura26mYoQAAAAQklEQVQ4y2MYnIC5cBUYzISC3WCg4cBguAqbxG4VhijsEtsYpLBLbGJYhV1i96jEqMRgl8CVqHFmA5wZB3dWG5QAAARkNgfatSQtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/it@2x.png
// module id = WR1f
// module chunks = 0